
<div class="container-fluid mt-3">
    <div class="row">
        <div class="col common-list-wrapper">
            <ul class="nav nav-pills flex-column">
                <li class="nav-item">
                    <a routerLink="connections" routerLinkActive="active" class="nav-link" aria-current="page">
                        <i class="w-14 me-1 text-dark fa-solid fa-list"></i>
                        Lista de conexões
                    </a>
                </li>
                <li class="nav-item">
                    <a routerLink="global-settings" routerLinkActive="active" class="nav-link" aria-current="page">
                        <i class="w-14 me-1 text-dark fa-solid fa-gear"></i>
                        Configurações globais
                    </a>
                </li>
                <li class="nav-item">
                    <a routerLink="integration-test" routerLinkActive="active" class="nav-link" aria-current="page">
                        <i class="w-14 me-1 text-dark fa-solid fa-flask text-dark me-1"></i>
                        Teste de integração
                    </a>
                </li>           
            </ul>                  
        </div>        
        <div class="col h-100">               
            <router-outlet></router-outlet>
        </div>
    </div>
</div>